import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/instacks_ui/src/components/not-found-view.tsx");
